var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-draggable-resizable",
    {
      key: _vm.posX,
      staticStyle: { "z-index": "100" },
      attrs: {
        w: _vm.width,
        h: _vm.height,
        x: _vm.posX,
        y: _vm.posY,
        "max-width": 890,
        "max-height": 700,
        "min-width": 300,
        active: true,
        parent: true,
        resizable: _vm.isResizing,
        "drag-handle": ".drag",
        draggable: _vm.draggable,
        "class-name-handle": "object-form-resizable-handle"
      },
      on: { dragstop: _vm.onDragStop, resizing: _vm.onResizing }
    },
    [
      _c(
        "div",
        {
          key: _vm.height + _vm.width,
          staticClass: "home-floating-window-container drag elevation-1",
          style: { height: _vm.height },
          attrs: { id: "window" }
        },
        [
          _c(
            "v-layout",
            {
              staticClass: "home-floating-window-header",
              attrs: { row: "", "justify-space-between": "" }
            },
            [
              _c(
                "v-layout",
                { attrs: { row: "", "justify-start": "", "align-center": "" } },
                [
                  _vm._t("iconWindows"),
                  _vm._v("\n        " + _vm._s(_vm.title) + "\n      ")
                ],
                2
              ),
              _vm._v(" "),
              _c("window-header-button", {
                attrs: { mode: "dark" },
                on: { onClick: _vm.closeWindows }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider", { staticStyle: { margin: "0 20px" } }),
          _vm._v(" "),
          _vm._t("objectDivWindows")
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d213bc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d213bc2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectWindow/HomeFloatingWindow.vue
// module id = null
// module chunks = 